import React from 'react';
import { Alert } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import { isInstagramAudioSupported } from 'app/modules/posts/modules/post/modules/instagramAudio';
import { useLegacyPostExperienceSwitch } from 'app/modules/posts/modules/post/hooks/useLegacyPostExperienceSwitch';

interface PostComposerContentInstagramAudioNoticeProps {
  pageType: number;
  subtype: number;
}

const PostComposerContentInstagramAudioNotice = ({
  pageType,
  subtype,
}: PostComposerContentInstagramAudioNoticeProps) => {
  const { t } = useTranslation();
  const isAudioAvailable = isInstagramAudioSupported(pageType, subtype);
  const { switchExperience } = useLegacyPostExperienceSwitch();

  if (!isAudioAvailable) {
    return null;
  }

  return (
    <Alert
      variant="info"
      cta={{
        label: t('instagramAudio.legacyNoticeCta'),
        onClick: () => switchExperience(),
        position: 'bottom',
      }}
    >
      {t('instagramAudio.legacyNotice')}
    </Alert>
  );
};

export default PostComposerContentInstagramAudioNotice;
